/*
  Accordion two PDP: keeps aria-expanded in sync with the "open" class.
  Opening/closing and the timer are handled by the shared accordion component in base.js,
  which only toggles the class (also when the timer moves to the next item).
*/
(() => {
  "use strict";

  const ITEM_SELECTOR = ".accordion-two-pdp__item";
  const observed = new WeakSet();

  const sync = (item) => {
    const toggle = item.querySelector("[data-toggle]");
    if (!toggle) return;
    toggle.setAttribute("aria-expanded", item.classList.contains("open") ? "true" : "false");
  };

  const init = (root) => {
    root.querySelectorAll(ITEM_SELECTOR).forEach((item) => {
      if (observed.has(item)) return;
      observed.add(item);
      sync(item);
      new MutationObserver(() => sync(item)).observe(item, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });
  };

  init(document);
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
